/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import Layer from './Layer';
import './index.scss';

export default class Info extends Component {
  onClose = () => {
    this.props.onClose();
  };

  render() {
    const { children, ...rest } = this.props;
    return (
      <Layer
        containerStyle={{
          top: 200
        }}
        {...rest}
      >
        <div className="mp-layer-title">提示</div>
        <div className="mp-layer-info">{children}</div>
        <div className="mp-layer-infobtn" onClick={this.onClose}>
          <a>我知道了</a>
        </div>
      </Layer>
    );
  }
}
